import React from 'react';
import { useChatStore } from '../store/chatStore';
import { useListConversations } from '../../../api/conversations';
import { useUserProfile } from '../../../api/profile';

import { useTranslation } from 'react-i18next';

interface ChatHeadingProps {
  className?: string;
}

export const PleriInitialMessage = () => {
  const { t } = useTranslation('pleri/chat');
  const { data: userProfile } = useUserProfile();
  return <>{t('heyHowCanIHelp', { name: userProfile?.name })}</>;
};

export const ChatHeading: React.FC<ChatHeadingProps> = ({ className = '' }) => {
  const activeConversationId = useChatStore(
    (state) => state.activeConversationId,
  );
  const { data: conversationsData } = useListConversations();

  // Get conversation title if it exists
  const conversationTitle = conversationsData?.conversations?.find(
    (c) => c.conversationId === activeConversationId,
  )?.title;

  // Show conversation title if it exists, otherwise show default message
  const headingContent = conversationTitle ? (
    <>{conversationTitle}</>
  ) : (
    <PleriInitialMessage />
  );

  return (
    <h1 className={`mb-10 font-semibold tracking-tight ${className}`}>
      {headingContent}
    </h1>
  );
};
